import { render, staticRenderFns } from "./AdditionalSales.vue?vue&type=template&id=204d4725&scoped=true"
import script from "./AdditionalSales.vue?vue&type=script&lang=js"
export * from "./AdditionalSales.vue?vue&type=script&lang=js"
import style0 from "./AdditionalSales.vue?vue&type=style&index=0&id=204d4725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@6.11.0_webpack@5.104.1__lodash@4_6a4e8631f36538c7428b4f6a46ee29d3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d4725",
  null
  
)

export default component.exports